import { Action } from "redux";
import { isType } from "typescript-fsa";

import { ICalendarSettingsState, ISearchToolbarState } from "../classes/state";
import { initialSearchToolbarState } from "./initialState";

import * as types from "../actions/actionTypes";
import * as actions from "../actions/searchToolbarActions";

export default function searchToolbarReducer(state: ISearchToolbarState = initialSearchToolbarState, action: Action): ISearchToolbarState {

  if (isType(action, actions.setSearch)) {
    const newState: ISearchToolbarState = {
      ...state,
      searchText: action.payload.searchText,
      selectedSearchCategoryValue: action.payload.searchCategory,
      selectedSearchFilterValue: action.payload.searchFilter,
    };
    return newState;
  }

  if (isType(action, actions.loadCalendarSettingsSuccess)) {
    const newState: ISearchToolbarState = {
      ...state,
      searchCategoryOptions: action.payload.categoryOptions,
      searchFilterOptions: action.payload.filterOptions,
    };
    return newState;
  }

    // if (isType(action, actions.loadFilterOptionsSuccess)) {
  //   const newState: ISearchToolbarState = {
  //     ...state,
  //     searchFilterOptions: action.payload,
  //   };
  //   return newState;
  // }

  // if (isType(action, actions.loadCategoryOptionsSuccess)) {
  //   const newState: ISearchToolbarState = {
  //     ...state,
  //     searchCategoryOptions: action.payload,
  //   };
  //   return newState;
  // }

  return state;
};
